<template>
      <transition name="transitionevent">
        <div class="full-screen-container" v-if="isOpen">
          <div class="head">
              <h2><slot name="header"></slot></h2>
              <div class="back" @click="close()" >
                <img src="/static/img/Arrow.svg" alt=""/> <span>{{backText}}</span>
              </div>
          </div>
          <div class="content">
            <slot name="content"></slot>
          </div>
        </div>
      </transition>
</template>

<script>
export default {
  props: {
    backText:{
      type: String,
      default:'Zurück zur Startseite'
    }
  },
  data () {
    return {
      isOpen: false,
    }
  },
  methods: {
    open:function() {
        this.isOpen = true;
        //to disable scrolling when this component is opened;
        document.querySelector('body').classList.add('no-scroll');

    },
    close:function(routerGo=true) {
        this.isOpen = false;
        var vm=this;
        //disable scrolling block
        document.querySelector('body').classList.remove('no-scroll');
        if(vm.$route.params.slug && routerGo) {
          vm.$event.$emit('userinteraction', {item:'close fullscreen', from:vm.$route.path});
          vm.$router.go(-1);
        }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.full-screen-container{
  position: fixed;
  top:0;
  left:0;
  width:100vw;
  height: 100vh;
  background-color: white;
  z-index:9;
  overflow-y: auto;
  //font-size: 1.5em;
  &.no-head-padding{
    .head{
      padding:0!important;
    }
  }
  .head{
    background-color:$dark-blue-bg;
    min-height:9%;
    display: flex;
    justify-content: center;
    align-items: center;
    @include for-size(phone-only) {
      padding-top:10vw;
    }
    h2{
      color:white;
      font-weight: 600;
      font-style: normal;
      text-decoration: none;
      font-size:2em;
      font-family: acumin-pro-semi-condensed, sans-serif;
      @include for-size(phone-only) {
        margin:5vw 0;
      }
    }
    .back {
      color: white;
      cursor: pointer;
      position: absolute;
      @include for-size(phone-only) {
        top:5vw;
      }
      left:5%;
      white-space: nowrap;
      font-weight: 700;
      transition: 1.5s all 0s ease;
      img {
        width: 4vw;
        transform: rotate(180deg);
        margin-right: 5%;
      }
    }
  }
  .content{
    width:100%;
    height:91%;
    position: relative;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/elements/FullScreen.vue